import persistedState from "@/store/plugins/persistedState";

export default [persistedState];
